import { Directive, ElementRef, Input } from "@angular/core";
import { environment } from "../../../environments/environment";


// tslint:disable-next-line:directive-selector
@Directive({
    selector: '[err-img]',
    host: { '(error)':'onError($event)'}
})
export class NoImageDirective { 
    @Input('err-img')
    fallbackImageUrl: string;   
    constructor(private elementRef: ElementRef) {
    }
    /**
     * Fallback Image will be shown, when the image is broken
     * @param  {any} event
     * @returns void
     */
    onError(event: any): void{
        if (environment.production) {
            this.elementRef.nativeElement.src =  environment.uiTemplateBaseUrl + '/images/no_image.png';
        } else {
            this.elementRef.nativeElement.src = environment.uiTemplateBaseUrl + '/images/no_image.png';
        }
    }
}